<div class="section section-padding">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="section-title text-left">
                    <p class="subtitle">07 --- Call To Action</p>
                    <h4 class="title">The Unparalleled Experience We Have.</h4>
                    <p>Possibly the first commercial camping ground in the world was Cunningham's camp, near Douglas, Isle of Man, which opened in 1894 In 1906 the Association of Cycle Campers opened its first own camping site.</p>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="sigma_counter">
                            <span> <b class="counter" [countUp]="2000">0</b> <span class="custom-primary">+</span> </span>
                            <p>Adventure Done</p>
                        </div>
                    </div> 
                    <div class="col-sm-4">
                        <div class="sigma_counter">
                            <span> <b class="counter" [countUp]="100">0</b> <span class="custom-primary">+</span> </span>
                            <p>Team Members</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6"> 
                <div class="sigma_box cta_form">
                    <div class="circles">
                        <div class="circle-2"></div>
                        <div class="circle-3"></div>
                        <div class="circle-4"></div> 
                    </div>
                    <h5>Get a Full Quote</h5>
                    <form (ngSubmit)="onSubmit()" #contactForm="ngForm">
                        <div class="form-group">
                            <input type="text" placeholder="Full Name" class="form-control" name="name" [(ngModel)]="model.name" required>
                        </div>
                        <div class="form-group">
                            <input type="email" placeholder="Email I'd" class="form-control" name="email" [(ngModel)]="model.email" required>
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Phone No." class="form-control" name="phone" [(ngModel)]="model.phone" required>
                        </div>
                        <div class="form-group">
                            <input type="text" placeholder="Write Message..." class="form-control" name="message" [(ngModel)]="model.message" required>
                        </div>
                        <button type="submit" class="sigma_btn-custom secondary" name="button">Get A Quote</button>
                        <!-- Form Messages -->
                        <div class="service-error mt-4 w-100" *ngIf="error">
                            <ngb-alert type="danger" class="mb-0 w-100" [dismissible]="false">
                                <strong>Oops!</strong> Something bad happened. Please try again later.
                            </ngb-alert>
                        </div>
                        <div [hidden]="!submitted" class="contact-message w-100 mt-4">
                            <div *ngIf="model.id" class="contact-success w-100">
                                <ngb-alert type="success" class="mb-0 w-100" [dismissible]="false">
                                    <strong>Success!</strong> Contact form has been successfully submitted.
                                </ngb-alert>
                            </div>
                        </div>
                        <!-- Form Messages -->
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>